import { createSlice } from "@reduxjs/toolkit";

export const samparkDispositionSlice = createSlice({
  name: "samparkDisposition",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    samparkDispositionList: [],
    model: false,
    error_msg: null,
    rowdata: {
      sampark_value: undefined,
      disposition_type: 1,
      display_name: undefined,
      description: undefined,
    },
    listCount: 0,
    samparkDispositionParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
      disposition_type: "",
    },
  },
  reducers: {
    getSamparkDispositions: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    samparkDispositionListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.samparkDispositionParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        samparkDispositionList: action.payload.response.results,
        loading: false,
        samparkDispositionParams: {
          ...state.samparkDispositionParams,
          no_of_pages: noofpages,
        },
      };
    },
    samparkDispositionAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    samparkDispositionAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {
          sampark_value: undefined,
          disposition_type: 1,
          display_name: undefined,
          description: undefined,
        },
      };
    },
    samparkDispositionEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    samparkDispositionEditSuccessful: (state) => {
      return { 
        ...state, 
        loading: false, 
        rowdata: {
          sampark_value: undefined,
          disposition_type: 1,
          display_name: undefined,
          description: undefined,
        },
      };
    },
    samparkDispositionDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {
            sampark_value: undefined,
            disposition_type: 1,
            display_name: undefined,
            description: undefined,
          },
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetSamparkDispositionParams: (state, action) => {
      return {
        ...state,
        samparkDispositionParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

export const {
  getSamparkDispositions,
  samparkDispositionListSuccessful,
  samparkDispositionAdd,
  samparkDispositionAddSuccessful,
  samparkDispositionEdit,
  samparkDispositionEditSuccessful,
  samparkDispositionDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetSamparkDispositionParams,
} = samparkDispositionSlice.actions;

export default samparkDispositionSlice.reducer;
